import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppRoutingCanDeactivateDetails } from 'life-goal-rest';
import { ErrorHandlerModuleService } from 'r2-error-handler-module';
export interface CanComponentDeactivate {
  canDeactivate: (state) => Observable<AppRoutingCanDeactivateDetails>;
}


@Injectable()
export class GeneralDeactivateGuardService implements CanDeactivate<CanComponentDeactivate> {

  constructor(private errorHandlerService: ErrorHandlerModuleService) {}

  canDeactivate(component: CanComponentDeactivate, currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): any {

    if (component.canDeactivate) {
      return component.canDeactivate(nextState).pipe(
        map((results) => {
          if (results.isValid) {
            return results.isValid;
          } else {
            this.errorHandlerService.openInformationSnackBar(results.message, 2000);
            return results.isValid;
          }
        })
      );
    }
    return true;
  }
}
